import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ErrorResponse } from "react-router-dom";
import {
  convertReferralFirstPurchase,
  deactivateReferralProgram,
  updateReferralConfig,
} from "hooks/api/referral";
import { translate } from "shared/languages";
import { invalidateCustomerList } from "hooks/mutations/customerList";
import { getApiErrorMessage, getApiSuccessMessage } from "shared/utils";

export const useUpdateReferralConfig = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateReferralConfig,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["referral"] });
      getApiSuccessMessage(translate("referral.toast.config_saved"));
    },
    onError: (error: AxiosError<ErrorResponse>) => getApiErrorMessage(error),
  });
};

export const useDeactivateReferralProgram = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deactivateReferralProgram,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["referral"] });
      getApiSuccessMessage(translate("referral.toast.deactivated"));
    },
    onError: (error: AxiosError<ErrorResponse>) => getApiErrorMessage(error),
  });
};

// The conversion records a real purchase, so the package namespace refetches
// alongside the referral views (same invalidation the buy modal uses). The
// success toast is left to the caller — the popup words it by outcome
// (converted / recorded-only / discount applied).
export const useConvertReferralFirstPurchase = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: convertReferralFirstPurchase,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["referral"] });
      queryClient.invalidateQueries({ queryKey: ["customer_package"] });
      invalidateCustomerList(queryClient);
    },
    onError: (error: AxiosError<ErrorResponse>) => getApiErrorMessage(error),
  });
};
